import { useEffect, useRef } from 'react';

export const useEffectRunOnce = (callback: () => void, enable: boolean) => {
  const isRun = useRef<boolean>(false);

  useEffect(() => {
    if (isRun.current || !enable) return;

    callback();
    isRun.current = true;
  }, [callback, enable]);
};
